(function () {
    'use strict';

    angular
        .module('sod.helper')
        .directive('tilesEditableDetails', tilesEditableDetail);

    function tilesEditableDetail(ActionManager, lodash) {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                onApply: '=',
                onCancel: '=',
                // onRemove: '&?',
                validation:'=?',
                mode: '@'
            },
            require: 'ngModel',
            template: '',
            link: function(scope, elem, attr, ctrl) {
                scope.model = {};
                scope.mem = {
                    onAddAttachmentClick: onAddAttachmentClick,
                };

                ctrl.$formatters.push(function(modelValue) {
                    scope.default = angular.copy(modelValue);
                   return modelValue.edit_model;
                });

                ctrl.$parsers.push(function(viewValue) {
                    return angular.merge(scope.default, { edit_model: viewValue}) ;
                });

                ctrl.$render = function() {
                    scope.model = ctrl.$viewValue;
                };

                scope.onApply = function() {
                    ctrl.$setViewValue(scope.model);
                };

                scope.onCancel = function() {
                    scope.model = angular.copy(scope.default.edit_model);
                    ctrl.$setViewValue(scope.model);
                };

                function onAddAttachmentClick(field) {
                    const docLibOptions = lodash.get(scope, 'options.attachmentOptions', {});
                    ActionManager('open-document-library', docLibOptions).then(function(result) {
                        result.modal.closed.then(function(res) {
                            if (res !== false) {
                                // add to model
                                scope.model[field] = res;
                            }
                        });
                    });
                }
            },
            controller: tilesEditableDetailCtrl,
        };
    }

    function tilesEditableDetailCtrl($scope, $compile, $element, lodash, $templateCache) {
        var templateField = '';
        var templateUrlField = '';

        this.$onInit = function() {
            templateField = ($scope.mode === 'new') ? 'newTemplate' : 'editTemplate';
            templateUrlField = ($scope.mode === 'new') ? 'newTemplateUrl' : 'editTemplateUrl';

            initTemplate();
        }

        function initTemplate() {
            var template = '';

            if (lodash.has($scope, 'options.' + templateField)) {
                template = $scope.options[templateField];
            } else {
                if (lodash.has($scope, 'options.' + templateUrlField)) {
                    template = $templateCache.get($scope.options[templateUrlField]);
                }
            }
            $element.html(template);
            $compile($element.contents())($scope);
        }
    }
})();